class CollectionDescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.updateOverflow = this.updateOverflow.bind(this);
  }

  connectedCallback() {
    this.content = this.querySelector('.collection-description__content');
    this.button = this.querySelector('.collection-description__toggle');

    if (!this.content || !this.button) return;

    this.button.addEventListener('click', this.handleClick);
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.updateOverflow);
      this.resizeObserver.observe(this.content);
    } else {
      window.addEventListener('resize', this.updateOverflow);
    }
    requestAnimationFrame(this.updateOverflow);

    if (document.fonts?.ready) {
      document.fonts.ready.then(this.updateOverflow);
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.updateOverflow);
  }

  handleClick() {
    const isExpanded = this.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', String(isExpanded));
    this.button.textContent = isExpanded ? this.dataset.lessLabel : this.dataset.moreLabel;
  }

  updateOverflow() {
    if (this.classList.contains('is-expanded')) return;

    const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;
    this.button.hidden = !hasOverflow;
  }
}

if (!customElements.get('collection-description-toggle')) {
  customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}
